import { useMemo } from "react";
import moment from "moment";
import DOMPurify from "dompurify";
import { readNotification, removeNotification } from "./action";
import { useDispatch, useSelector } from "react-redux";
import { isMobile } from "react-device-detect";

import { Accordion, useAccordionButton } from "react-bootstrap";

DOMPurify.addHook("afterSanitizeAttributes", function (node) {
  // set all elements owning target to target=_blank
  if ("target" in node) {
    let url = node.getAttribute("href");
    if (!url.match(/^https?:\/\//i)) {
      url = "http://" + url;
    }
    node.setAttribute("href", url);
    node.setAttribute("target", "_blank");
    node.setAttribute("rel", "noopener");
  }
});

const Notification = ({ notification }) => {
  const dispatch = useDispatch();
  const showAll = useSelector((state) => state?.notifications?.showAll);

  const handleRead = () => {
    readNotification(notification.id, showAll, dispatch);
  };

  const handleRemove = () => {
    removeNotification(notification.id, showAll, dispatch);
  };

  const dateTime = useMemo(() => moment(notification.updated_at).format("MMM DD, YYYY") + " at " + moment(notification.updated_at).format("hh:mm A"), []);

  function CustomToggle({ children, eventKey }) {
    const decoratedOnClick = useAccordionButton(eventKey, () => console.log("totally custom!"));

    return (
      <div className="cursor-pointer" onClick={decoratedOnClick}>
        {children}
      </div>
    );
  }

  return (
    <>
      {isMobile ? (
        <li className={`px-2 notifyItem ${notification.read_status ? "read" : ""} ${
          !notification.read_status ? "active" : ""
        }`} style={{ cursor: "pointer", listStyle: "none" }} onClick={handleRead}>
          <div className="mb-3">
            <p className="date text-sm text-gray-600 mb-0">{dateTime}</p>
            <div className="d-flex justify-content-between">
              <p className="mb-0 fw-bold text-capitalize mb-1">
                {/* <i class={notification.read_status ? "d-none" : "fa-solid fa-circle-small text-primary"}></i> */}
                {notification.title}
              </p>
              <i className="fa-regular fa-circle-xmark ml-2 text-danger" style={{ cursor: "pointer" }} onClick={handleRemove}></i>
            </div>
            <div
              className={`${!isMobile && "d-none"} lastChild text-md`}
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(notification.description),
              }}
            ></div>
            {/* <p className="date">{dateTime}</p> */}
          </div>
        </li>
      ) : (
        <>
          {/* <OverlayTrigger
            placement={"left"}
            trigger={["hover", "focus"]}
            show={show}
            rootClose={true}
            overlay={
              <div className="notification-main" onMouseEnter={() => setShow(true)} onMouseLeave={() => setShow(false)}>
                <div
                  className="innerNoti"
                  dangerouslySetInnerHTML={{
                    __html: DOMPurify.sanitize(notification.description),
                  }}
                ></div>
              </div>
            }
          >
            <li
              className={notification.read_status && "read"}
              style={{ cursor: "pointer" }}
              onClick={handleRead}
              ref={target}
              onMouseEnter={() => setShow(true)}
              onMouseLeave={() => setShow(false)}
            >
              <div className="px-3">
                <div className="border-bottom pb-3 mb-3">
                  <div className="d-flex justify-content-between">
                    <p className="mb-0">
                      <i className={notification.read_status ? "d-none" : "fa-solid fa-circle-small text-primary"}></i> {notification.title}
                    </p>
                    <i className="fa-regular fa-circle-xmark ml-2 text-danger" style={{ cursor: "pointer" }} onClick={handleRemove}></i>
                  </div>
                  <p className="date">{date}</p>
                </div>
              </div>
            </li>
          </OverlayTrigger> */}
          <div className={`px-3 py-2 notifyItem ${!notification.read_status ? "active" : ""}`} onClick={handleRead}>
            <CustomToggle eventKey={notification?.id}>
              <p className="mb-0 text-sm text-gray-600">
                {dateTime}
              </p>
              <div className="d-flex justify-content-between">
                <p className="mb-2 fw-bold">{notification.title}</p>
                <i className="fa-regular fa-circle-xmark ml-2 text-danger" style={{ cursor: "pointer" }} onClick={handleRemove}></i>
              </div>
            </CustomToggle>
            <Accordion.Collapse eventKey={notification?.id}>
              <div
                className="innerNoti"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(notification.description),
                }}
              ></div>
            </Accordion.Collapse>
          </div>
        </>
      )}
    </>
  );
};

export default Notification;
